module.exports = __webpack_public_path__ + "img/code-html-sm.7f03ee82.webp";